import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import utilitiesGTM from '../../utilities/utilitiesGTM';

const propTypes = {
  url: PropTypes.string.isRequired,
  displayContent: PropTypes.string.isRequired,
  gtmData: PropTypes.instanceOf(Object).isRequired,
  userData: PropTypes.instanceOf(Object).isRequired,
  newTab: PropTypes.bool,
  activeSection: PropTypes.string,
};

const CTALink = ({
  url,
  displayContent,
  gtmData,
  activeSection = null,
  newTab = false,
  userData,
}) => (
  <a
    href={url}
    target={newTab ? '_blank' : ''}
    rel={newTab ? 'noopener noreferrer' : ''}
    onClick={() => {
      if (window.dataLayer) {
        utilitiesGTM.gtmDataLayerPushEvent(
          gtmData.EVENT,
          gtmData.BANNER_GTM_DATA.category,
          gtmData.BANNER_GTM_DATA.action,
          gtmData.SECTIONS[activeSection].LEARN_MORE,
          userData.uid ? userData.uid : 'null',
        );
      }
    }}
  >
    {displayContent}
  </a>
);

CTALink.propTypes = propTypes;

const mapStateToProps = state => ({
  userData: state.user.userData,
});

export default connect(mapStateToProps, null)(CTALink);
